import utils from '@src/common/utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '640px',
    emptyText: '暂无数据',
    menu: false,
    column: [
      {
        label: '年度',
        prop: 'year',
        search: true,
        searchSlot: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      {
        label: '月份',
        prop: 'month',
        search: false,
        searchSlot: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      // {
      //   label: '建筑名称',
      //   prop: 'buildName',
      //   search: false,
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   editDisabled: false,
      //   overHidden: true,
      //   align: 'center'
      // },
      // {
      //   label: '建筑名称',
      //   prop: 'buildId',
      //   search: false,
      //   searchSlot: true,
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: false,
      //   editDisabled: false,
      //   overHidden: true,
      //   align: 'center',
      //   hide: true
      // },

      {
        label: '谷时',
        prop: 'vtime',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      // {
      //   label: '谷阈值',
      //   prop: 'vthreshold',
      //   search: false,
      //   searchSlot: false,
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   editDisabled: false,
      //   overHidden: true,
      //   align: 'center',
      // },
      {
        label: '谷电价',
        prop: 'vprice',
        searchSlot: false,
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center'
      },
      {
        label: '峰时',
        prop: 'ptime',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      // {
      //   label: '峰阈值',
      //   prop: 'pthreshold',
      //   search: false,
      //   searchSlot: false,
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   editDisabled: false,
      //   overHidden: true,
      //   align: 'center',
      // },
      {
        label: '峰电价',
        prop: 'pprice',
        searchSlot: false,
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center'
      },
      {
        label: '平时',
        prop: 'ftime',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      // {
      //   label: '平时阈值',
      //   prop: 'fthreshold',
      //   search: false,
      //   addDisplay: false,
      //   editDisplay: false,
      //   viewDisplay: true,
      //   editDisabled: false,
      //   overHidden: true,
      // },
      {
        label: '平时电价',
        prop: 'fprice',
        searchSlot: false,
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center'
      },
      {
        label: '创建人',
        prop: 'creator',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: false,
        align: 'center',
      },
      {
        label: '创建时间',
        prop: 'createTime',
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        type: 'datetimerange',
        viewDisplay: false,
        align: 'right',
        hide: false,
        span: 24,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
    ],
  }
}
